import React from 'react';
import './GradientBG.css';

const GradientBG = () => {
  return (
    <div className="gradient-bg" id="gradient-bg" aria-hidden="true">
      <div className="aurora-base" />
      <div className="aurora-highlights" />
      <div className="aurora-haze" />
      <div className="aurora-curve-shadow" />
      <div className="aurora-vignette" />
    </div>
  );
};

export default GradientBG;
